import { render, staticRenderFns } from "./SwipeCountReport.vue?vue&type=template&id=255342b0"
import script from "./SwipeCountReport.vue?vue&type=script&lang=js"
export * from "./SwipeCountReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports